export const PRODUCTS = {
  RAAMSTICKERS: 'Raamstickers',
  PROJECTBORDEN: 'Projectborden',
  PRINT_PRODUCTION: 'Drukwerk',
};
